import { render, staticRenderFns } from "./otherProcess.vue?vue&type=template&id=98d06bc0&scoped=true&"
import script from "./otherProcess.vue?vue&type=script&lang=js&"
export * from "./otherProcess.vue?vue&type=script&lang=js&"
import style0 from "./otherProcess.vue?vue&type=style&index=0&id=98d06bc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d06bc0",
  null
  
)

export default component.exports